module.exports = __webpack_public_path__ + "img/banner.de48b3ef.png";